import { SVGProps } from 'react';

const SvgVenus = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m19.662 3.953-7.32 12.678a2.52 2.52 0 0 1-4.36 0L6.699 14.41a.026.026 0 0 1 .005-.037.026.026 0 0 1 .036.006 2.108 2.108 0 0 0 3.304-.44l6.128-10.623a2.108 2.108 0 0 0-1.286-3.09.026.026 0 0 1-.026-.027c0-.007.003-.013.007-.018a.026.026 0 0 1 .019-.008h2.597a2.52 2.52 0 0 1 2.18 3.78ZM10.998.173H8.46a.026.026 0 0 0 0 .05 1.273 1.273 0 0 1 .647 1.818l-3.7 6.397a1.275 1.275 0 0 1-1.945.307.026.026 0 0 0-.041.031l1.299 2.255a1.662 1.662 0 0 0 2.88 0l4.839-8.364A1.662 1.662 0 0 0 10.998.173Zm-8.808 0a2.19 2.19 0 1 0 0 4.38 2.19 2.19 0 0 0 0-4.38Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgVenus;
